<template>
  <div>
    <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
      <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad" />
      <div>
        <w-signal-strength-legend class="mr-r4"/>
        <w-header-search-button @click="onShowSearchToolButtonClick"></w-header-search-button>
      </div>
    </el-row>
    <el-row>
      <w-ap-client-table :data="tableData" :loading="loading" :show-search-tool="showSearchTool" :obj-company-id="selectedNode ? selectedNode.obj.objCompanyId : null" />
    </el-row>
  </div>
</template>

<script>
import { isNil, isEmpty, clone } from 'lodash';
import msgUtil from '@/utils/message';
import { analysisTimeType } from '@/constants/performance';
import commonAPI from '@/api/performance/common';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import WApClientTable from '@/views/performance/components/wireless/ApClientTable';
import WSignalStrengthLegend from '@/views/performance/node/analysis/wireless-ap/components/SignalStrengthLegend';

export default {
  name: 'WClientTable',
  mixins: [analysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
    WApClientTable,
    WSignalStrengthLegend,
  },
  props: {
    operationFlag: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      checkDatetime: null,
      total: null,
      showSearchTool: false,
    };
  },
  methods: {
    /**
     * 접속자 정보를 조회한다.
     */
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
      };
      if (this.timeType === analysisTimeType.HIST.value && !this.operationFlag) {
        params.baselineDatetime = this.plotLineDatetime;
        params.managetypeId = 'NMS';
        this.loading = true;
        // 스냅샷
        commonAPI
          .getApClientStateList(params)
          .then((response) => {
            if (response.data.success === true) {
              const snapshotData = response.data.data;
              const docInfo = snapshotData.snapshotDoc;
              if (!isNil(docInfo)) {
                docInfo.forEach((item) => {
                  if (isEmpty(item.clientName)) {
                    item.clientName = clone(item.ipAddress);
                  }
                });
                this.tableData = docInfo;
              } else {
                this.tableData = [];
              }
              this.checkDatetime = snapshotData.timestamp;
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '접속자 정보', false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '접속자 정보', false));
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = true;
        // 현재
        commonAPI
          .getClientInfoByWireless(params)
          .then((result) => {
            if (result.data.success) {
              const tableInfo = result.data.data;
              if (!isNil(tableInfo)) {
                tableInfo.forEach((item) => {
                  if (isEmpty(item.clientName)) {
                    item.clientName = clone(item.ipAddress);
                  }
                });
                this.tableData = tableInfo;
              } else {
                this.tableData = [];
              }
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '접속자 정보', false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '접속자 정보', false));
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    /**
     * 검색 헤더 버튼 클릭 이벤트 핸들러
     * @author Ju
     */
    onShowSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
    // 오버라이딩
    onCurrentDataReLoad() {
      this.loadData(true);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/wireless-ap/components/table/ClientTable.vue